import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import InvoiceProcessor from './components/InvoiceProcessor';
import { AuthProvider } from './contexts/AuthContext';
import MobileNotification from './components/common/MobileNotification';

export default function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-black text-[#c8c2bd]">
        <div className="bg-glow"></div>
        <Header />
        <main className="relative z-10 max-w-[1440px] mx-auto px-6 lg:px-12 py-8 mt-20">
          <Routes>
            <Route path="/" element={<InvoiceProcessor />} />
          </Routes>
        </main>
        <MobileNotification />
      </div>
    </AuthProvider>
  );
}